export default __webpack_public_path__ + "static/media/boite5.4db309c0.jpg";